


$(window).load(function() {
  $('.flexslider').flexslider({
    animation: "slide",
    animationLoop: false,
    itemWidth: 210,
    itemMargin: 5,
    minItems: 1,
    maxItems: 3,
    move: 1
  });
});

$('span.carret').click(function(){
var obj = $(this).siblings('.site-nav__dropdown');
    $(this).siblings('.site-nav__dropdown').toggle();
    $(".site-nav__dropdown").not(obj).hide();
  });
$(document).ready(function () {
 $(".up").on('click', function () {
   var cart_no = $(this).siblings(".cart__qty-input");
	 $(cart_no).val(parseInt( $(cart_no).val()) + 1);
   
});
  
  $(".fancybox").fancybox({
		openEffect	: 'none',
		closeEffect	: 'none',
    	afterClose	:	function() {
            window.location.reload();
		}
	});
  
});
var toAdd = new Array();
$(document).ready(function(){
    
  $(".product-form").submit(function(e) {
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartBtn = $addToCartForm.find('.cart_btn');

    var value={};
    $(this).find("[name='id[]']").each(function(){
      if($(this).val()>="-10000"){
        toAdd.push({
          variant_id: $(this).val(),        
          quantity_id: $("#Quantity").val()
        });
      }
    });
  
    // $.post('/cart/add.js', {updates: value},function(event){
  //event.preventDefault();
   //   debugger;
//});
    
    
    function moveAlong(){
      if (toAdd.length) {
        var request = toAdd.shift();
        var tempId= request.variant_id;
        var tempQty = request.quantity_id;
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          type: 'post',
          data: 'quantity='+tempQty+'&id='+tempId,
          beforeSend: function() {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
            $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
          },
          success: function(item) {
			moveAlong();
            
          },
          error: function(XMLHttpRequest) {
            moveAlong();
          }
        });

      }
      else {				
        if($("#fancy-popup").length>0)
            {
              $("#fancy-popup").click(); 
            }

            window.setTimeout(function(){
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
            }, 1000);


            //$.getJSON("/cart.js", function(cart) {
            //  refreshCart(cart);
            //});
      }  
    };
	moveAlong();


    return false;
    });
 

 }); 

$('.niceScroll').mCustomScrollbar({ 
axis:"y"
});
$('.niceScroll2').mCustomScrollbar({ 
axis:"x",
autoDraggerLength: "true"
});
  
            setHeight();
        
        
            
             function setHeight() {
                
                 windowHeight = $(window).innerHeight();
              
              $('.cart_column').css('min-height', windowHeight - (250)*2);
              $('.cart_column').css('height', windowHeight - (250)*2);
              
                  
  
             }



$(document).ready(function(){
  
  $('.video-image').on('click', function(e){
    $(".pro_image").addClass("no-js");
    $(".pro_video").removeClass("no-js");
  });

  $('.imageVideo').on('click', function(e){    
    $(".pro_image").removeClass("no-js");
    $(".pro_video").addClass("no-js");
  });

  Widgetiphone15()
  Widgetiphone12()
  WidgetiphoneAlle()
  WidgetWatch()
  WidgetSamsung()
  WidgetForsideJS()
  WidgetProductPage()
  WidgetMacBook()
  WidgetComputer()
  WidgetUdvalgtekategorier()
  WidgetMobilTilbehor()
  WidgetForsideGadgets()
  WidgetiPad()
  PopularekategorierForside()
  AppleWatchRemme()
  iPhoneCoverForside()
  WidgetKabler()
  WidgetTilbehor()
  iPadCover()
});







<!-- iPhone 15/16/17 START -->
function Widgetiphone15 () {
 	var placeholder = $('.Widgetiphone15');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
        <br>
        <br>
        <br>
        <div class="Uniktoptekst"><b>Tilbehør til iPhone</b></div>
		<div class="page-width">
        <div class="row100">



        
        <div style="background-color: #fff;" class="column100"><a href="/collections/mobil_opladerstation">
        <img alt="Magsafe Ladestation til iPhone" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DDown.png?v=1732059122" loading="lazy">
        <p>Ladestation /<br>trådløs oplader</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="/collections/in_ear_headset_horetelefoner">
        <img alt="Trådløse Earbuds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bii0.png?v=1732058781" loading="lazy">
        <p>Headset & <br>hovedtelefoner</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="/collections/magsafe-tilbehor-iphone-12-13-14-15">
        <img alt="Trådløs MagSafe Oplader til Bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/SizeFiz_dc84182e-8246-43c5-a73a-d7e87e698523.png?v=1773267965" loading="lazy">
        <p>MagSafe <br>tilbehør</p>
        </a></div>



        
        <div style="background-color: #fff;" class="column100"><a href="/collections/usb-mobiloplader-vaegoplader">
        <img alt="sense trådløs biloplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/XX9.png?v=1732057974" loading="lazy">
        <p>USB oplader<br>til mobil</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="/collections/mobil_kabel">
        <img alt="Lightning Opladnings Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80.png?v=1732058291" loading="lazy">
        <p>Kabel & <br>adaptere</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="/collections/powerbank">
        <img alt="Anker 533 Powerbank" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DOwn22.png?v=1732060347" loading="lazy">
        <p>Powerbank<br> stort udvalg</p>
        </a></div>
    
        
        </div>
      </div>
	`);
}
<!-- iPhone 15/16/17 SLUT -->










<!-- iPhone 12 / 13 / 14 START -->
function Widgetiphone12 () {
 	var placeholder = $('.Widgetiphone12');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
        <br>
        <br>
        <br>
        <div class="Uniktoptekst"><b>Tilbehør til iPhone</b></div>
		<div class="page-width">
        <div class="row100">



        <div style="background-color: #fff;" class="column100"><a href="/collections/mobil_opladerstation">
        <img alt="Magsafe Ladestation til iPhone" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DDown.png?v=1732059122" loading="lazy">
        <p>Ladestation /<br>trådløs oplader</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="/collections/in_ear_headset_horetelefoner">
        <img alt="Trådløse Earbuds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bii0.png?v=1732058781" loading="lazy">
        <p>Headset & <br>hovedtelefoner</p>
        </a></div>


           <div style="background-color: #fff;" class="column100"><a href="/collections/magsafe-tilbehor-iphone-12-13-14-15">
        <img alt="Trådløs MagSafe Oplader til Bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80_64a74522-d58c-4c1a-8bbb-124e8a3303ee.png?v=1754145358" loading="lazy">
        <p>MagSafe <br>tilbehør</p>
        </a></div>



        
        <div style="background-color: #fff;" class="column100"><a href="/collections/usb-mobiloplader-vaegoplader">
        <img alt="sense trådløs biloplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/XX9.png?v=1732057974" loading="lazy">
        <p>USB oplader<br>til mobil</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="/collections/mobil_kabel">
        <img alt="Lightning Opladnings Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80.png?v=1732058291" loading="lazy">
        <p>Kabel & <br>adaptere</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="/collections/powerbank">
        <img alt="Anker 533 Powerbank" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DOwn22.png?v=1732060347" loading="lazy">
        <p>Powerbank<br> stort udvalg</p>
        </a></div>
        
      
        
        </div>
      </div>
	`);
}
<!-- iPhone 12 / 13 / 14 SLUT -->






<!-- iPhone 5 til 11 START -->
function WidgetiphoneAlle () {
 	var placeholder = $('.WidgetiphoneAlle');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
        <br>
        <br>
        <br>
        <div class="Uniktoptekst"><b>Tilbehør til iPhone</b></div>
		<div class="page-width">
        <div class="row100">


        
        <div style="background-color: #fff;" class="column100"><a href="/collections/mobil_opladerstation">
        <img alt="Magsafe Ladestation til iPhone" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DDown.png?v=1732059122" loading="lazy">
        <p>Ladestation /<br>trådløs oplader</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="/collections/in_ear_headset_horetelefoner">
        <img alt="Trådløse Earbuds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bii0.png?v=1732058781" loading="lazy">
        <p>Headset & <br>hovedtelefoner</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="/collections/mobilholder-til-bil">
        <img alt="Trådløs MagSafe Oplader til Bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/MM90.png?v=1732058552" loading="lazy">
        <p>Holder til bil <br>biltilbehør</p>
        </a></div>



        
        <div style="background-color: #fff;" class="column100"><a href="/collections/usb-mobiloplader-vaegoplader">
        <img alt="sense trådløs biloplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/XX9.png?v=1732057974" loading="lazy">
        <p>USB oplader<br>til mobil</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="/collections/mobil_kabel">
        <img alt="Lightning Opladnings Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80.png?v=1732058291" loading="lazy">
        <p>Kabel & <br>adaptere</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="/collections/powerbank">
        <img alt="Anker 533 Powerbank" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DOwn22.png?v=1732060347" loading="lazy">
        <p>Powerbank<br> stort udvalg</p>
        </a></div>




        
        </div>
      </div>
	`);
}
<!-- iPhone 5 til 11 SLUT -->





<!-- Apple Watch ALLE START -->
function WidgetWatch () {
 	var placeholder = $('.WidgetWatch');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
<div class="Uniktoptekst"><b>Tilbehør til Apple Watch</b></div>

<div class="page-width">
<div class="row100">



<div style="background-color: #fff;" class="column100"><a href="/collections/apple-watch-cover">
<img alt="44mm NX beskyttelsesglas der bliver sat på et Apple Watch" src="https://cdn.shopify.com/s/files/1/1563/9239/files/nx-250.png?v=1632087229" loading="lazy">
<p>NX 360° cover M.<br> beskyttelseglas</p>
</a></div>


<div style="background-color: #fff;" class="column100"><a href="/collections/apple-watch-laenkevaerktoj-skift-af-led/products/aluminium-tpu-laenkevaerktoj-2-0-til-skift-af-led-i-metal-stal-urrem-bla">
<img alt="Aluminium Lænkeværktøj til skift af led i Metal" src="https://cdn.shopify.com/s/files/1/1563/9239/files/LONKEBK.png?v=1703022330" loading="lazy">
<p>Lænkeværktøj 2.0<br> til skift af led</p>
</a></div> 

   
<div style="background-color: #fff;" class="column100"><a href="/collections/apple-watch-tilbehor/products/apple-watch-oplader-hvid">
<img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/OP9030.png?v=1703022700" loading="lazy">
<p>Magnetisk trådløs<br> oplader - 1M</p>
</a></div>

  
<div style="background-color: #fff;" class="column100"><a href="/products/apple-watch-night-stand-oplader-stander-ladedock-sort">
<img alt="Ladedock i sort med et Apple Watch sat på" src="https://cdn.shopify.com/s/files/1/1563/9239/files/stander-sort-250.png?v=1632086663" loading="lazy">
<p>Apple Watch<br> night stand - Sort</p>
</a></div>


<div style="background-color: #fff;" class="column100"><a href="/collections/opladerstation/products/delx-3-i-1-quick-charge-tradlos-docking-ladestation-15w-sort">
<img alt="Quick Charge Trådløs Docking Ladestation i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DDown.png?v=1732059122" loading="lazy">
<p>DeLX™ 3-i-1<br> ladestation - Sort</p>
</a></div>

  
<div style="background-color: #fff;" class="column100"><a href="/collections/apple-watch-tilbehor/products/apple-watch-cnc-aluminium-dock-oplader-stand-solv">
<img alt="Aluminium oplader stand i sølv, med et Apple Watch sat på den" src="https://cdn.shopify.com/s/files/1/1563/9239/files/gray-250.png?v=1632087357" loading="lazy">
<p>CNC aluminium<br> oplader stand</p>
</a></div>

  

</div>
</div>
	`);
}
<!-- Apple Watch ALLE SLUT -->
















<!-- Samsung ALLE START -->
function WidgetSamsung () {
 	var placeholder = $('.WidgetSamsung');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
        <br>
        <br>
        <br>
        <div class="Uniktoptekst"><b>Tilbehør til Samsung</b></div>
		<div class="page-width">
        <div class="row100">




        

       <div style="background-color: #fff;" class="column100"><a href="/collections/mobil_opladerstation">
        <img alt="Magsafe Ladestation til Samsung Galaxy" src="https://cdn.shopify.com/s/files/1/1563/9239/files/SamsungOplader.png?v=1737636724" loading="lazy">
        <p>Ladestation /<br>trådløs oplader</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="/collections/in_ear_headset_horetelefoner">
        <img alt="Trådløse Earbuds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bii0.png?v=1732058781" loading="lazy">
        <p>Headset & <br>hovedtelefoner</p>
        </a></div>

        <div style="background-color: #fff;" class="column100"><a href="/collections/mobilholder-til-bil">
        <img alt="Trådløs MagSafe Oplader til Bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/MM90.png?v=1732058552" loading="lazy">
        <p>Holder til bil <br>Biltilbehør</p>
        </a></div>

        <div style="background-color: #fff;" class="column100"><a href="/collections/usb-mobiloplader-vaegoplader">
        <img alt="sense trådløs biloplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/XX9.png?v=1732057974" loading="lazy">
        <p>USB oplader<br>til mobil</p>
        </a></div>

        <div style="background-color: #fff;" class="column100"><a href="/collections/mobil_kabel">
        <img alt="Lightning Opladnings Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80.png?v=1732058291" loading="lazy">
        <p>Kabel & <br>Adaptere</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="/collections/powerbank">
        <img alt="Anker 533 Powerbank" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DOwn22.png?v=1732060347" loading="lazy">
        <p>Powerbank<br> Stort udvalg</p>
        </a></div>


        </div>
      </div>
	`);
}
<!-- Samsung ALLE SLUT -->
 

  

<!-- LADESTATION ALLE START -->  
function WidgetForsideJS () {
 	var placeholder = $('.WidgetForsideJS');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        <div class="Uniktoptekst2">
        
        <b>Mest Populære i oplader</b>
        <a href="/collections/mobil_opladerstation">
        <p>Se alle produkter > </p>
        </a>
        </div>


        
        <!-- DeLX™ 3-i-1 Ladestation - Sort -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="delx-3-i-1-quick-charge-tradlos-docking-ladestation-15w-sort" 
     data-link="/collections/opladerstation/products/delx-3-i-1-quick-charge-tradlos-docking-ladestation-15w-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="DeLX™ 3-i-1 Ladestation - Sort" loading="lazy">
    <p>DeLX™ 3-i-1<br> Ladestation - Sort</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>



<!-- X97 -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="mobilholder-til-instrumentbraet-selvklaebende-360-rotation" 
     data-link="/collections/magsafe-tilbehor-iphone-12-13-14-15/products/mobilholder-til-instrumentbraet-selvklaebende-360-rotation">
  <a class="product-link" href="#">
    <img class="product-image" alt="X97 Magnetisk Mobilholder Sugekop 360° MagSafe kompatibel" loading="lazy">
    <p>X97 Magnetisk Mobilholder</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>




<!-- ESSAGER™ 45W USB Biloplader -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="essager-45w-biloplader-usb-a-usb-c-sort" 
     data-link="/collections/usb-biloplader-mobil/products/essager-45w-biloplader-usb-a-usb-c-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="ESSAGER™ 45W USB Biloplader" loading="lazy">
    <p>ESSAGER™ 45W <br>USB Biloplader</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- GaN-Pro™ 240W USB Ladestation -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="usb-ladestation-4x-usb-a-4x-type-c-240w-gan-pro" 
     data-link="/collections/mobil_opladerstation/products/usb-ladestation-4x-usb-a-4x-type-c-240w-gan-pro">
  <a class="product-link" href="#">
    <img class="product-image" alt="GaN-Pro™ 240W USB Ladestation" loading="lazy">
    <p>GaN-Pro™ 240W<br>USB Ladestation</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- 65W QuickCharge Vægoplader -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="65w-quickcharge-3-0-pd-multi-port-vaegoplader-hvid" 
     data-link="/collections/usb-mobiloplader-vaegoplader/products/65w-quickcharge-3-0-pd-multi-port-vaegoplader-hvid">
  <a class="product-link" href="#">
    <img class="product-image" alt="65W QuickCharge Vægoplader" loading="lazy">
    <p>65W QuickCharge<br> Vægoplader</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>



<!-- JOYROOM™ 3-i-1 Ladestation -->
<!--
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="joyroom-coil-fold-3-i-1-tradlos-docking-ladestation-15w-sort" 
     data-link="/collections/mobil_opladerstation/products/joyroom-coil-fold-3-i-1-tradlos-docking-ladestation-15w-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="JOYROOM™ 3-i-1 Ladestation" loading="lazy">
    <p>JOYROOM™ 3-i-1 Ladestation</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>
-->






<!-- ESSAGER™ 20W Oplader -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="lux-3-i-1-tradlos-ladestation-til-iphone-12-13-14-s-m-magsafe-15w" 
     data-link="/collections/mobil_opladerstation/products/lux-3-i-1-tradlos-ladestation-til-iphone-12-13-14-s-m-magsafe-15w">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>3-i-1 Trådløs <br>Oplader - Sort</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>







        </div>
      </div>
	`);
}
<!-- LADESTATION ALLE SLUT -->  



  
<!-- GADGETS ALLE START -->  
function WidgetForsideGadgets () {
 	var placeholder = $('.WidgetForsideGadgets');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row500">
        
        <div class="Uniktoptekst2">
        <b>Mest populære gadgets</b>
        <a href="/pages/gadgets">
        <p>Se alle produkter > </p>
        </a>
        </div>

<!-- MEST POPULÆRE GADGETS - START -->




 <!-- GPS DRONE -->
 <!--
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="fpv-4k-drone-dual-kamera-wifi-sort" 
     data-link="/collections/tilbud/products/fpv-4k-drone-dual-kamera-wifi-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="Professionel Drone 4K - GPS" loading="lazy">
    <p>Professionel Drone <br> 4K - GPS</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>
-->



<!-- Bodytrimmer -->
<!--
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="trimmaster-vandtaet-bodytrimmer-sort" 
     data-link="/collections/trimmer/products/trimmaster-vandtaet-bodytrimmer-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="Bodytrimmer V.3.0" loading="lazy">
    <p>Multifunktionel <br> Bodytrimmer V.3.0</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>
-->


<!-- DeLX™ | 3-i-1 Quick Charge Trådløs Docking Ladestation 15W - Sort -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="delx-3-i-1-quick-charge-tradlos-docking-ladestation-15w-sort" 
     data-link="/collections/gaveideer/products/delx-3-i-1-quick-charge-tradlos-docking-ladestation-15w-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>DeLX™ | 3-i-1<br> Ladestation 15W</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- XDOBO™ Bluetooth-højtaler -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="xdobo-bluetooth-hojtaler-m-x5-ipx6-vandtaet-design-sort" 
     data-link="/collections/bluetooth-hojtaler/products/xdobo-bluetooth-hojtaler-m-x5-ipx6-vandtaet-design-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>XDOBO™<br> Bluetooth-højtaler</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>



<!-- Dashcam 4K -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="dashcam-til-bil-uhd-4k-30fps-g-sensor-blackbox" 
     data-link="/products/dashcam-til-bil-uhd-4k-30fps-g-sensor-blackbox">
  <a class="product-link" href="#">
    <img class="product-image" alt="4K Ultra HD Dashcam" loading="lazy">
    <p>4K Ultra HD<br> Dashcam</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>




<!-- Multistyler -->
<!--
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="professionel-combo-styler-letvaegt-hurtig-stojsvag-6-i-1-styler" 
     data-link="/collections/plejeprodukter/products/professionel-combo-styler-letvaegt-hurtig-stojsvag-6-i-1-styler">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Multistyler<br>6-i-1 Professionel</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>
-->

<!-- ROCK™ HIFI -->
<!--
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="rock-hifi-over-ear-tradlos-headset-med-mic-bluetooth-5-0-sort" 
     data-link="/collections/gaveideer/products/rock-hifi-over-ear-tradlos-headset-med-mic-bluetooth-5-0-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="X97 Magnetisk Mobilholder" loading="lazy">
    <p>ROCK™ HIFI<br>Trådløs Headset</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>
-->



<!-- Carplay Adapter -->
<!--
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="tradlos-carplay-adapter-5ghz-wi-fi-bluetooth-5-0-sort" 
     data-link="/collections/vinter-udsalg-1/products/tradlos-carplay-adapter-5ghz-wi-fi-bluetooth-5-0-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="Carplay Adapter til bil Carabc" loading="lazy">
    <p>Carplay Adapter<br> til bil Carabc™</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>
-->

<!-- ACTION-5K Adapter -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="action5k-wifi-hd-sportskamera-sony-386-sensor-sort" 
     data-link="/collections/gaveideer/products/action5k-wifi-hd-sportskamera-sony-386-sensor-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="Carplay Adapter til bil Carabc" loading="lazy">
    <p>ACTION-5K HD<br> Action Kamera</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- SkyPro Mini 4K Adapter -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="mini-drone-4k-dual-camera-letvaegtsdrone-m-dobbelte-kameraer-gra" 
     data-link="/collections/gaveideer/products/mini-drone-4k-dual-camera-letvaegtsdrone-m-dobbelte-kameraer-gra">
  <a class="product-link" href="#">
    <img class="product-image" alt="Carplay Adapter til bil Carabc" loading="lazy">
    <p>SkyPro™ Mini 4K<br> Letvægtsdrone</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- MotionMate™ Aktivitetsur Adapter -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="motionmate-aktivitetsur-ip67-vandtaet-smartwatch-sort" 
     data-link="/collections/smart-watch-aktivitetsur/products/motionmate-aktivitetsur-ip67-vandtaet-smartwatch-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>MotionMate™<br> Aktivitetsur IP68</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>



<!-- Sovemaske - 100% -->
<!--
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="soft-mask-intelligent-ojenmaske-ultimativ-blackout" 
     data-link="/collections/sovemaske/products/soft-mask-intelligent-ojenmaske-ultimativ-blackout">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Sovemaske 100%<br> mørklægning</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>
-->


        </div>
      </div>
	`);
}
<!-- GADGETS ALLE SLUT -->







<!-- Mobil tilbehør ALLE START -->  

function WidgetTilbehor () {
 	var placeholder = $('.WidgetTilbehor');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row500">
        
        <div class="Uniktoptekst2">
        <b>POPULÆRT MOBIL TILBHEØR</b>
        <a href="/pages/mobil-tablet-computer-tilbehor">
        <p>Se alle produkter > </p>
        </a>
        </div>

<!-- POPULÆRT MOBIL TILBHEOR - START -->




 <!-- Magcold™ 3-i-1 -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="magcold-3-i-1-foldbar-ladestation-15w-hvid" 
     data-link="/collections/mobil_opladerstation/products/magcold-3-i-1-foldbar-ladestation-15w-hvid">
  <a class="product-link" href="#">
    <img class="product-image" alt="Professionel Drone 4K - GPS" loading="lazy">
    <p>Magcold™ 3-i-1 <br> Ladestation</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- Lenovo LP40 Headset -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="lenovo-wireless-in-ear-horetelefoner-m-opladningsboks" 
     data-link="/products/lenovo-wireless-in-ear-horetelefoner-m-opladningsboks">
  <a class="product-link" href="#">
    <img class="product-image" alt="Lenovo™ LP40 trådløst Headset" loading="lazy">
    <p>Lenovo™ LP40<br> trådløst Headset</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>
 

<!-- YESIDO® 15W -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="yesido-15w-tradlos-biloplader-m-sugekop-sort" 
     data-link="/collections/mobilholder-til-bil/products/yesido-15w-tradlos-biloplader-m-sugekop-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>YESIDO® - 15W <br> Trådløs Biloplader</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- MagSafe Powerbank -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="delx-magnetisk-tradlos-powerbank-5000-mah-hvid" 
     data-link="/collections/powerbank/products/delx-magnetisk-tradlos-powerbank-5000-mah-hvid">
  <a class="product-link" href="#">
    <img class="product-image" alt="MagSafe Powerbank 5000mAh" loading="lazy">
    <p>MagSafe Powerbank<br> 5.000mAh</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- Trådløs Mikrofon (USB-C) - PULUZ™ -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="puluz-professionel-tradlos-mikrofon-usb-c-sort" 
     data-link="/collections/mikrofon-til-iphone/products/puluz-professionel-tradlos-mikrofon-usb-c-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>PULUZ™ <br> Mikrofon (USB-C)</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- ESSAGER™ 20W Sort -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="essager-usb-c-vaegoplader-3-0-hurtigoplader-20w-sort" 
     data-link="/collections/usb-mobiloplader-vaegoplader/products/essager-usb-c-vaegoplader-3-0-hurtigoplader-20w-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="ESSAGER™ 2-Port 20W - Sort" loading="lazy">
    <p>ESSAGER™<br>20W - Sort</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- ROCK™ HIFI -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="rock-hifi-over-ear-tradlos-headset-med-mic-bluetooth-5-0-sort" 
     data-link="/collections/gaveideer/products/rock-hifi-over-ear-tradlos-headset-med-mic-bluetooth-5-0-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="X97 Magnetisk Mobilholder" loading="lazy">
    <p>ROCK™ HIFI<br>Trådløs Headset</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- MMobilholder til Instrumentbræt | Selvklæbende - JOYROOM™ -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="joyroom-360-mobilholder-til-instrumentbraettet" 
     data-link="/collections/mobilholder-til-bil/products/joyroom-360-mobilholder-til-instrumentbraettet">
  <a class="product-link" href="#">
    <img class="product-image" alt="MagSafe Bilholder" loading="lazy">
    <p>Mobilholder til<br> Instrumentbrættet</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- Yesido® YPS1 -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="yesido-yps1-35w-powerbank-20-000-mah-sort" 
     data-link="/collections/powerbank/products/yesido-yps1-35w-powerbank-20-000-mah-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Yesido® YPS1<br> 20.000 mAh</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- Qi Magnetisk 3-i-1 -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="delx-qi-magnetisk-3-i-1-tradlos-fast-charger-foldbart-design" 
     data-link="/collections/mobil_opladerstation/products/delx-qi-magnetisk-3-i-1-tradlos-fast-charger-foldbart-design">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Qi Magnetisk 3-i-1<br>MagSafe Oplader </p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- HAWEEL® - Justerbar -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="haweel-justerbar-mobil-tablet-holder-sort" 
     data-link="/collections/mobil-stativ-mobilstander-bordholder/products/haweel-justerbar-mobil-tablet-holder-sort">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>HAWEEL® Justerbar<br> Mobil holder</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- Lenovo® | LP40 Pro -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="lenovo-lp40-pro-tradlose-in-ear-headset-bt-5-1-hvid" 
     data-link="/collections/in_ear_headset_horetelefoner/products/lenovo-lp40-pro-tradlose-in-ear-headset-bt-5-1-hvid">
  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Lenovo® LP40 Pro<br> Headset BT 5.1 </p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>




        </div>
      </div>
	`);
}
<!-- Mobil tilbehør ALLE SLUT -->



















<!-- MOBIL TILBEHØR ALLE START -->
function WidgetMobilTilbehor () {
 	var placeholder = $('.WidgetMobilTilbehor');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row500">
        <div class="Uniktoptekst2">
        
        <b>Mest Populære Tilbehør</b>
        <a href="/pages/mobil-tilbehor">
        <p>Se alle produkter > </p>
        </a>
        </div>


       <div style="background-color: #fff;" class="column500"><a href="/collections/mobil_opladerstation"><img alt="Quick Charge Trådløs Docking Ladestation i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/H1b2269a357304ce58ab6d59ef71db9e5b_530x_2a39a37b-957e-494d-a017-fe7ad075999f.png?v=1668099519" loading="lazy">
        <p>Mobil Ladestation</p>
        </a></div>

       <div style="background-color: #fff;" class="column500"><a href="/collections/mobil-tradlos-oplader"><img alt="wivu trådløs oplader i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/v10_530x_ae242bd7-5686-4013-848d-6218ec336f39.png?v=1668167364" loading="lazy">
        <p>Trådløs oplader</p>
        </a></div>
        



        <div style="background-color: #fff;" class="column500"><a href="/collections/mobilholder-til-bil"><img alt="Baseus Biloplader til bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_530x_a12f7d8a-38b8-4ea5-99e0-8eb758d82185.png?v=1668167057" loading="lazy">
        <p>Mobilholder til bil</p>
        </a></div>

        





        <div style="background-color: #fff;" class="column500"><a href="/collections/mobil_kabel"><img alt="USB-A til Lightning Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/laloop_530x_fe71073f-2205-4992-ade9-417b995449d3.png?v=1668167489" loading="lazy">
        <p>Mobil kabel</p>
        </a></div>


    <div style="background-color: #fff;" class="column500"><a href="/collections/mobil_lobe_armband"><img alt="Løbearmbånd til Smartphones i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/v1_93d6e46b-fcd5-4873-9ab2-54705b5766bd_530x_1.png?v=1668167263" loading="lazy">
        <p>Mobil løbeudstyr</p>      
        </a></div>

              <div style="background-color: #fff;" class="column500"><a href="/collections/cykel-mobil-holder"><img alt="Løbearmbånd til Smartphone" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_a8a81dab-e16e-4efc-a765-04165fdc7f04_530x_1.png?v=1668166838" loading="lazy">
        <p>Cykel mobilholder</p>
        </a></div>



        </div>
      </div>
	`);
}
<!-- MOBIL TILBEHØR ALLE SLUT -->









<!-- AUDIO & HIFI TILBEHØR ALLE START -->
function WidgetUdvalgtekategorier () {
 	var placeholder = $('.WidgetUdvalgtekategorier');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        
        <div class="Uniktoptekst2">
        <b>Bestseller kategorier</b>
        <a href="/pages/mobil-tablet-computer-tilbehor">
        <p>Se alle produkter > </p>
        </a>
        </div>





        <div style="background-color: #fff;" class="column500"><a href="/collections/usb-biloplader-mobil">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/RGB.png?v=1722100636" loading="lazy">
        <p>USB<br>Oplader</p>
        <div class="Textallign">

        </div>
        </a></div>



                 <div style="background-color: #fff;" class="column500"><a href="/collections/smart-watch-aktivitetsur">
                 <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/4_673b26ef-99f4-4510-8dc6-8b60f45eb703.jpg?v=1710628187" loading="lazy">
        <p>SmartWatch<br>Ur</p>
        <div class="Textallign">

        </div>
        </a></div>



        <div style="background-color: #fff;" class="column500"><a href="/collections/magsafe-tilbehor-iphone-12-13-14">
        <img alt="Lenovo™ 4Run Løbe/Fitness Ear Buds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/5_877bbb5b-a105-4a65-9c61-0fd3bfcd044d.jpg?v=1710628186" loading="lazy">
        <p>MagSafe<br>Tilbehør</p>
        <div class="Textallign">  
        </div>
        </a></div>




        <div style="background-color: #fff;" class="column500"><a href="/collections/mobil_lobe_armband">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Lovb.png?v=1722099916" loading="lazy">
        <p>Løbearmbånd<br>& træning</p>
        <div class="Textallign">
        </div>
        </a></div>

  
        <div style="background-color: #fff;" class="column500"><a href="/collections/fpv-drone">
        <img alt="4K Starter Drone" src="https://cdn.shopify.com/s/files/1/1563/9239/files/6_a399e1af-15cb-4437-8545-e84084b8abc8.jpg?v=1710628187" loading="lazy">
        <p>Kamera<br>droner</p>
        <div class="Textallign">
        </div>
        </a></div>




<!-- -->


        <div style="background-color: #fff;" class="column500"><a href="/collections/powerbank">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/BB_667d026b-7fef-4623-8a55-e551f5de5c22.png?v=1722099015" loading="lazy">
        <p>Powerbank<br> m. solcelle</p>
        <div class="Textallign">
        </div>
        </a></div>




        <div style="background-color: #fff;" class="column500"><a href="/collections/gadgets-til-bilen">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Screen2.png?v=1741731939" loading="lazy">
        <p>Gadgets<br>til bilen</p>
        <div class="Textallign">
        </div>
        </a></div>



          <div style="background-color: #fff;" class="column500"><a href="/collections/dashcam-bilkamera">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Dash.png?v=1722099330" loading="lazy">
        <p>Dashcam<br>4K UHD</p>
        <div class="Textallign">
        </div>
        </a></div>

          <div style="background-color: #fff;" class="column500"><a href="/collections/rejsegadgets">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/KKU.png?v=1722099766" loading="lazy">
        <p>Rejse<br>Gadgets</p>
        <div class="Textallign">
        </div>
        </a></div>



        <div style="background-color: #fff;" class="column500"><a href="/collections/computer-rygsaek">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Rygg.png?v=1722100131" loading="lazy">
        <p>Computer<br>Rygsække</p>
        <div class="Textallign">
        </div>
        </a></div>

 
        <div style="background-color: #fff;" class="column500"><a href="/collections/apple-airtag-noeglering-keychain">
        <img alt="Sort Ægte læder Airtag nøglering" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_a70d1c72-0c50-49be-bc60-6e7e0943d265.jpg?v=1710628187" loading="lazy">
        <p>AirTag<br>Tilbehør</p>
        <div class="Textallign">
        </div>
        </a></div>

        
        <div style="background-color: #fff;" class="column500"><a href="/pages/airpods-cover-tilbehor">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/PP20.png?v=1722100469" loading="lazy">
        <p>AirPods<br>Tilbehør</p>
        <div class="Textallign">
        </div>
        </a></div>
  


        </div>
      </div>
	`);
}
<!-- AUDIO & HIFI TILBEHØR ALLE SLUT -->




<!-- POPULÆRE PRODUKT KATEGORIER ALLE START -->
function PopularekategorierForside () {
 	var placeholder = $('.PopularekategorierForside');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        
        <div class="Uniktoptekst2">
        <b>Mest Populære i Audio og HiFi</b>
        <a href="/collections/in_ear_headset_horetelefoner">
        <p>Se alle produkter > </p>
        </a>
        </div>



        <div style="background-color: #fff;" class="column500"><a href="/products/lenovo-wireless-in-ear-horetelefoner-m-opladningsboks"><img alt="Lenovo™ LP40 trådløst Headset" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DOWN2_530x_b6ece73f-9de9-43ed-a620-2a7a7e9b1701.png?v=1681211274" loading="lazy">
        <p>Lenovo™ LP40<br> trådløst Headset</p>
        <div class="Textallign">
        <h5>262 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">349 kr.</h5>
        </div>
        </a></div>


         <div style="background-color: #fff;" class="column500"><a href="/collections/over-ear-hovedtelefoner-headset/products/rock-hifi-over-ear-tradlos-headset-med-mic-bluetooth-5-0-sort"><img alt="ROCK Over ear headset sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/2_1cf96238-d685-4d13-bf07-ea29ab6fdc85_530x_1.png?v=1681148387" loading="lazy">
        <p>ROCK™ Over Ear<br> Headset BT 5.0</p>
        <div class="Textallign">
        <h5>637 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">749 kr.</h5>
        </div>
        </a></div>

        
        <div style="background-color: #fff;" class="column500"><a href="/collections/in_ear_headset_horetelefoner/products/lenovo-wireless-ear-buds-touch-opladningsboks"><img alt="Lenovo™ 4Run Løbe/Fitness Ear Buds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Maskin0_530x_3354143f-6fb4-40e9-b9ae-113cdc7f6f5b.png?v=1668085517" loading="lazy">
        <p>Lenovo™ 4Run<br> Fitness Buds</p>
        <div class="Textallign">
        <h5>407 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">479 kr.</h5>
        </div>
        </a></div>


                 <div style="background-color: #fff;" class="column500"><a href="/products/joyroom-jr-ml01-bluetooth-hojtaler-subwoofer"><img alt="Joyroom Højtaler i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/products/1_2033df15-b656-4897-836b-276aed760b82.png?v=1638397405" loading="lazy">
        <p>JOYROOM™<br> BT Højtaler</p>
        <div class="Textallign">
        <h5>169 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">199 kr.</h5>
        </div>
        </a></div>
   

        <div style="background-color: #fff;" class="column500"><a href="/collections/in_ear_headset_horetelefoner/products/kumi-t9s-tradlose-horetelefoner-bluetooth-5-0-sort"><img alt="KUMI™ T9S In-Ear Touch Headset" src="https://cdn.shopify.com/s/files/1/1563/9239/files/v10_530x_a6e06383-8efa-4c59-aee6-86153a3dcf0f.png?v=1668085825" loading="lazy">
        <p>KUMI™ T9S<br> Touch Headset</p>
        <div class="Textallign">
        <h5>280 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">329 kr.</h5>
        </div>
        </a></div>


        <div style="background-color: #fff;" class="column500"><a href="/collections/bluetooth_oresnegl_handfri_headset/products/mono-headset-oresnegl-med-opladningsetui-sort"><img alt="MONO Håndfri Øresnegl M. Etui" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_530x_a360a229-e242-44c7-9d6c-91d85ea52f7a.png?v=1668085974" loading="lazy">
        <p>MONO Håndfri<br> Øresnegl M. Etui</p>
        <div class="Textallign">
        <h5>322 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">379 kr.</h5>
        </div>
        </a></div>


        </div>
      </div>
	`);
}
<!-- POPULÆRE PRODUKT KATEGORIER ALLE SLUT -->








<!-- Mest populære iPhone Covers -->
function iPhoneCoverForside () {
 	var placeholder = $('.iPhoneCoverForside');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        
        <div class="Uniktoptekst2">
        <b>Mest Populære iPhone Cover</b>
        <a href="/pages/iphone-cover">
        <p>Se alle produkter > </p>
        </a>
        </div>



<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="aaa-iphone-16-pro-delx-magsafe-silikone-cover-gennemsigtig" 
     data-link="/collections/gennemsigtig-magsafe-cover">

  <a class="product-link" href="#">
    <img class="product-image" alt="DeLX™ MagSafe Silikone Cover" loading="lazy">
    <p>DeLX™ MagSafe Silikone Cover</p>
    <div class="Textallign">
      <h5 class="product-price">Indlæser pris...</h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="iphone-16-pro-dg-ming-vintage-2-in-1-laeder-etui-m-cover-brun" 
     data-link="/collections/dg-ming-2-i-1-laeder-cover">
 
  <a class="product-link" href="#">
    <img class="product-image" alt="DG.MING™ Vintage 2-In-1 Cover" loading="lazy">
    <p>DG.MING™ Vintage 2-I-1 Cover</p>
    <div class="Textallign">
      <h5 class="product-price">Indlæser pris...</h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="iphone-16-pro-vintage-2-in-1-laeder-etui-m-aftageligt-cover-sort-gra" 
     data-link="/collections/vintage-2-i-1">

  <a class="product-link" href="#">
    <img class="product-image" alt="Vintage 2-In-1 Læder Etui" loading="lazy">
    <p>Vintage 2-In-1 Læder Etui</p>
    <div class="Textallign">
      <h5 class="product-price">Indlæser pris...</h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>



      <div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="iphone-16-pro-caseme-noble-laeder-etui-pung-morkebrun" 
     data-link="/pages/rapid-search-results?q=caseme%E2%84%A2+noble+m%C3%B8rkebrun&sort_order=name_desc&page=2">

  <a class="product-link" href="#">
    <img class="product-image" alt="CaseMe™ Noble læder Etui" loading="lazy">
    <p>CaseMe™ Noble læder Etui</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="iphone-16-pro-nx-design-laeder-cover-m-kortholder-sort" 
     data-link="/pages/rapid-search-results?q=NX+Design+L%C3%A6dercover+sort">

  <a class="product-link" href="#">
    <img class="product-image" alt="NX Design™ Læder Cover" loading="lazy">
    <p>NX Design™ Læder Cover</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="iphone-16-pro-ultratynd-matte-series-cover-v-2-0-sort" 
     data-link="/pages/rapid-search-results?q=Ultratynd+Matte+Series+Cover+V.2.0+Sort&page=2">

  <a class="product-link" href="#">
    <img class="product-image" alt="Ultratynd Matte Cover V.2.0" loading="lazy">
    <p>Ultratynd Matte Cover V.2.0</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>




        </div>
      </div>
	`);
}
<!-- Mest populære iPhone Covers SLUT -->













  


<!-- APPLE WATCH REMME START -->
function AppleWatchRemme () {
 	var placeholder = $('.AppleWatchRemme');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        
        <div class="Uniktoptekst2">
        <b>Mest Populære i Apple Watch</b>
        <a href="/pages/apple_watch_remme_tilbehor">
        <p>Se alle produkter > </p>
        </a>
        </div>



       <!-- Verona Ægte Læder -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="apple-watch-42-45mm-verona-aegte-laeder-urrem-morkebrun" 
     data-link="/products/apple-watch-42-45mm-verona-aegte-laeder-urrem-morkebrun">

  <a class="product-link" href="#">
    <img class="product-image" alt="L'Empiri™ Verona Ægte Læder" loading="lazy">
    <p>L'Empiri™ Verona Ægte Læder</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- Milanese Sølv -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="apple-watch-38-41mm-milanese-rustfri-rem-solv" 
     data-link="/collections/apple-watch-remme-38mm-40mm-41mm/products/apple-watch-38-41mm-milanese-rustfri-rem-solv">

  <a class="product-link" href="#">
    <img class="product-image" alt="L'Empiri™ Milanese Loop - Sølv" loading="lazy">
    <p>L'Empiri™ Milanese Loop - Sølv</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- Nylon Rose -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="apple-watch-38-41mm-realike-nylon-urrem-armband-rose" 
     data-link="/collections/apple-watch-remme-38mm-40mm-41mm/products/apple-watch-38-41mm-realike-nylon-urrem-armband-rose">

  <a class="product-link" href="#">
    <img class="product-image" alt="L'Empiri™ Nylon Velcro Rem" loading="lazy">
    <p>L'Empiri™ Nylon Velcro Rem</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- 4Run Silikone -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="apple-watch-38-41mm-4run-silikone-sportsrem-hvid" 
     data-link="/collections/apple-watch-silikone-remme-38mm-40mm-41mm/products/apple-watch-38-41mm-4run-silikone-sportsrem-hvid">

  <a class="product-link" href="#">
    <img class="product-image" alt="4Run™ Silikone Sportsrem - Hvid" loading="lazy">
    <p>4Run™ Silikone Sportsrem - Hvid</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- Premium Stål Sort -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="apple-watch-38-41mm-delx-premium-316l-stal-rem-sort" 
     data-link="/collections/apple-watch-stal-remme-38mm-40mm-41mm/products/apple-watch-38-41mm-delx-premium-316l-stal-rem-sort">

  <a class="product-link" href="#">
    <img class="product-image" alt="L'Empiri™ Premium 316L Stål - Sort" loading="lazy">
    <p>L'Empiri™ Premium 316L Stål - Sort</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- Titanium Rem Sølv -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="apple-watch-42-44-se-45mm-ultra-lempiri-titan-aegte-titanium-rem-solv" 
     data-link="/products/apple-watch-42-44-se-45mm-ultra-lempiri-titan-aegte-titanium-rem-solv">

  <a class="product-link" href="#">
    <img class="product-image" alt="L'Empiri™ X35 Titanium Rem" loading="lazy">
    <p>L'Empiri™ X35 Titanium Rem</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


        </div>
      </div>
	`);
}
<!-- APPLE WATCH REMME SLUT -->






<!-- IPAD COVER START -->
function iPadCover () {
 	var placeholder = $('.iPadCover');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        
        <div class="Uniktoptekst2">
        <b>Mest Populære i iPad</b>
        <a href="/pages/ipad_cover">
        <p>Se alle produkter > </p>
        </a>
        </div>





<!-- Verona™ Multietui Ægte Læder -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="ipad-10-10-9-verona-multietui-aegte-laeder-cover-sort" 
     data-link="/pages/rapid-search-results?q=+Verona%E2%84%A2+Multietui++%C3%86gte+L%C3%A6der+Cover+-+Sort+Verona%E2%84%A2+Multietui+%C3%86gte+L%C3%A6der&page=2">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Verona™ Multietui Ægte Læder</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- Retro Diary™ Læder -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="ipad-10-10-9-retro-diary-vintage-360-onefold-laeder-cover-brun" 
     data-link="/pages/rapid-search-results?q=Retro+Diary%E2%84%A2+Vintage+360%C2%B0+Onefold+L%C3%A6der+Cover+-+Brun">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Retro Diary™ 360° Onefold</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- NX Design™ Trifold Cover -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="ipad-10-9-2022-10th-gen-nx-design-smart-trifold-laeder-cover-sort" 
     data-link="/pages/rapid-search-results?q=+NX+Design%E2%84%A2+Smart+Trifold+PU+L%C3%A6der+Cover+-+Sort">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>NX Design™ Trifold Cover</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- ToughCase™ 360° Håndværker Cover -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="ipad-10-10-9-toughcase-360-beskyttelse-etui-cover-sort" 
     data-link="/pages/rapid-search-results?q=ToughCase%E2%84%A2+360%C2%B0+H%C3%A5ndv%C3%A6rker+Cover+-+Sort">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>ToughCase™ 360° Håndværker Cover</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- Neopren Stødsikkert Sleeve -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="ipad-10-9-2022-10th-gen-haweel-neopren-stodsikkert-sleeve-gra" 
     data-link="/pages/rapid-search-results?q=Neopren+St%C3%B8dsikkert+Sleeve+-+Gr%C3%A5">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Neopren Stødsikkert Sleeve</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- DUX DUCIS™ Tastatur Cover -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="ipad-10-9-2022-10th-gen-dux-ducis-cover-m-magnetisk-tradlos-tastatur-sort" 
     data-link="/pages/rapid-search-results?q=DUX+DUCIS%E2%84%A2+Cover+M.+Magnetisk+Tr%C3%A5dl%C3%B8s+Tastatur+-+Sort">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>DUX DUCIS™ Tastatur Cover</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>





        </div>
      </div>
	`);
}
<!-- IPAD COVER SLUT -->















<!-- KABLER START -->
function WidgetKabler () {
 	var placeholder = $('.WidgetKabler');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        
        <div class="Uniktoptekst2">
        <b>Mest Populære i kabler</b>
        <a href="/collections/mobil_kabel">
        <p>Se alle produkter > </p>
        </a>
        </div>



<!-- Lightning til USB-A Kabel -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="lightning-oplade-data-sync-kabel-til-iphone-ipad-hvid-1m" 
     data-link="/collections/mobil_kabel/products/lightning-oplade-data-sync-kabel-til-iphone-ipad-hvid-1m">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Lightning til USB-A Kabel</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- Lightning til USB-C Kabel -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="lightning-til-usb-c-oplade-data-sync-kabel-til-iphone-ipad-hvid-1m" 
     data-link="/collections/mobil_kabel/products/lightning-til-usb-c-oplade-data-sync-kabel-til-iphone-ipad-hvid-1m">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Lightning til USB-C Kabel</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- UUSB-C til USB-C | Oplade Data/Sync Kabel - Hvid - 1M -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="usb-c-til-usb-c-oplade-data-sync-kabel-hvid-1m" 
     data-link="/collections/mobil_kabel/products/usb-c-til-usb-c-oplade-data-sync-kabel-hvid-1m">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>USB-C til USB-C Kabel</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>


<!-- USB-C Oplader QC 3.0 - PD 20W -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="haweel-usb-c-vaegoplader-quick-charge-20w-hvid" 
     data-link="/collections/usb-mobiloplader-vaegoplader/products/haweel-usb-c-vaegoplader-quick-charge-20w-hvid">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>USB-C Oplader QC 3.0 - PD 20W</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- USB-C Til USB-A Kabel -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="usb-c-oplade-datakabel-hvid-1m" 
     data-link="/collections/mobil_kabel/products/usb-c-oplade-datakabel-hvid-1m">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>USB-C Til USB-A Kabel</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>

<!-- Magnetisk Trådløs Oplader m. MagSafe -->
<div style="background-color: #fff;" 
     class="column500 product-sync" 
     data-handle="magsafe-tradlos-oplader-15w-hvid" 
     data-link="/collections/mobil-tradlos-oplader/products/magsafe-tradlos-oplader-15w-hvid">

  <a class="product-link" href="#">
    <img class="product-image" alt="" loading="lazy">
    <p>Magnetisk Trådløs Oplader m. MagSafe</p>
    <div class="Textallign">
      <h5 class="product-price"></h5>
      <h5 class="compare-price line"></h5>
    </div>
  </a>
</div>



        </div>
      </div>
	`);
}
<!-- KABLER SLUT -->


















function WidgetProductPage () {
 	var placeholder = $('.WidgetProductPage');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
        <div class="Uniktoptekst"><b><u>Andre kunder har også købt</u></b></div>
		<div class="page-width">
        <div class="row100">
        <div style="background-color: #fff;" class="column100"><a href="/collections/mobil-tilbehor-gadgets/products/stylus-kapacitiv-touch-pen-til-tablet-smartphone"><img alt="DeLX™ - Kapacitiv Stylus Pen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/NX_530x_0024d642-af1d-471e-a2be-651fe3b3934e.png?v=1678795972" loading="lazy">
        <p>DeLX™ - Kapacitiv Stylus Pen</p>
        </a></div>
        <div style="background-color: #fff;" class="column100"><a href="/collections/opladerstation/products/delx-3-i-1-quick-charge-tradlos-docking-ladestation-15w-sort"><img alt="DeLX™ - 3-i-1 Docking Ladestation" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_fc09c8f5-a266-4090-9f4e-8a50697842c9.png?v=1632393081" loading="lazy">
        <p>DeLX™ - 3-i-1 Docking Ladestation</p>
        </a></div>
        <div style="background-color: #fff;" class="column100"><a href="/products/lenovo-wireless-in-ear-horetelefoner-m-opladningsboks"><img alt="Lenovo™ LP40 trådløst in-ear Headset" src="https://cdn.shopify.com/s/files/1/1563/9239/files/LP401.png?v=1655120585" loading="lazy">
        <p>Lenovo™ LP40 trådløst in-ear Headset</p>
        </a></div>
        <div style="background-color: #fff;" class="column100"><a href="/collections/mobilholder/products/sense-tradlos-biloplader-automatisk-aben-lukke-funktion"><img alt="SENSE™ Trådløs biloplader Automatisk" src="https://cdn.shopify.com/s/files/1/1563/9239/files/v1_530x_c2a642b4-08a5-4f15-9c3b-ca4df770c5f0.png?v=1632393081" loading="lazy">
        <p>SENSE™ Trådløs biloplader Automatisk</p>
        </a></div>
        <div style="background-color: #fff;" class="column100"><a href="/collections/apple-kabel-adapter/products/lightning-oplade-data-sync-kabel-til-iphone-ipad-hvid-1m"><img alt="Lightning Oplade Data/Sync Kabel 1M" src="https://cdn.shopify.com/s/files/1/1563/9239/files/test1_530x_06f3b1cb-f46b-4df7-97d7-660359ca0335.png?v=1632393081" loading="lazy">
        <p>Lightning Oplade Data/Sync Kabel 1M</p>
        </a></div>
        <div style="background-color: #fff;" class="column100"><a href="/collections/mobilholder/products/baseus-gravity-tradlos-biloplader-ventilationsgitteret"><img alt="BASEUS Bilholder M. Trådløs Opladning Til Ventilationsgitteret" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_530x_6022b85a-af24-4649-bf93-e256ccac7b3a.png?v=1632393358" loading="lazy">
        <p>BASEUS™ Gravity Trådløs Biloplader</p>
        </a></div>
        </div>
      </div>
	`);
}

















function WidgetMacBook () {
 	var placeholder = $('.WidgetMacBook');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
<br>
<br>
<br>

    <div class="Uniktoptekst"><b><u>Anbefalet Tilbehør til MacBook</u></b></div>
		<div class="page-width">
        <div class="row100">
        
        <div style="background-color: #fff;" class="column200"><a href="/collections/macbook-pc-adapter"><img alt="Multifunktionel Adapter til enheder" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Flipped.png?v=1655458487" loading="lazy">
        <p>Adapter</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="/collections/macbook-oplader-kabel"><img alt="Vægoplader i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/vharger2.png?v=1646656223" loading="lazy">
        <p>Oplader & Kabel</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="/collections/macbook-webcam-privacy-cover"><img alt="Webcam Kamera Beskyttelse til Computer" src="https://cdn.shopify.com/s/files/1/1563/9239/files/webcam.png?v=1660126964" loading="lazy">
        <p>Webcam Tilbehør</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="/collections/tradlos-bluetooth-mus"><img alt="Trådløs Mus til MacBook" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Muse.png?v=1665480159" loading="lazy">
        <p>Trådløs Mus</p>
        </a></div>
      
        <div style="background-color: #fff;" class="column200"><a href="/collections/macbook-stander-holder"><img alt="Stander i sølv til MacBooks" src="https://cdn.shopify.com/s/files/1/1563/9239/files/STANDGG.png?v=1659653568" loading="lazy">
        <p>Stander / Holder</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="/collections/rengoring-og-vedligeholdelse"><img alt="Rengørings spray til skærme" src="https://cdn.shopify.com/s/files/1/1563/9239/files/spray2.png?v=1660128754" loading="lazy">
        <p>Rengøring</p>
        </a></div>
        </div>
      </div>
	`);
}




function WidgetComputer () {
 	var placeholder = $('.WidgetComputer');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
<br>
<br>
<br>

    <div class="Uniktoptekst"><b><u>Anbefalet Tilbehør til Computer</u></b></div>
		<div class="page-width">
        <div class="row100">
        
        <div style="background-color: #fff;" class="column200"><a href="/collections/computer-pc-adapter"><img alt="Multifunktionel Adapter til enheder" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Flipped.png?v=1655458487" loading="lazy">
        <p>Adapter</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="/collections/computer-pc-oplader-kabel"><img alt="Vægoplader i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/vharger2.png?v=1646656223" loading="lazy">
        <p>Oplader & Kabel</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="/collections/computer-pc-webcam-cover"><img alt="Webcam Kamera Beskyttelse til Computer" src="https://cdn.shopify.com/s/files/1/1563/9239/files/webcam.png?v=1660126964" loading="lazy">
        <p>Webcam cover</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="/collections/tradlos-bluetooth-mus"><img alt="Trådløs Mus til MacBook" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Muse.png?v=1665480159" loading="lazy">
        <p>Trådløs Mus</p>
        </a></div> 
        <div style="background-color: #fff;" class="column200"><a href="/collections/computer-pc-standere"><img alt="Stander i sølv til MacBooks" src="https://cdn.shopify.com/s/files/1/1563/9239/files/STANDGG.png?v=1659653568" loading="lazy">
        <p>Stander / Holder</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="/collections/rengoring-og-vedligeholdelse"><img alt="Rengørings spray til skærme" src="https://cdn.shopify.com/s/files/1/1563/9239/files/spray2.png?v=1660128754" loading="lazy">
        <p>Rengøring</p>
        </a></div>
         
        </div>
      </div>
	`);
}



<!-- iPad START -->
function WidgetiPad () {
 	var placeholder = $('.WidgetiPad');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
        <br>
        <br>
        <br>
        <div class="Uniktoptekst"><b>Tilbehør til iPad</b></div>
		<div class="page-width">
        <div class="row100">

        
        <div style="background-color: #fff;" class="column100"><a href="/collections/usb-mobiloplader-vaegoplader">
        <img alt="Quick Charge 3-i-1 Trådløs Docking Ladestation i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/300x.png?v=1686828061" loading="lazy">
        <p>USB oplader <br> til mobil</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="/collections/in_ear_headset_horetelefoner">
        <img alt="Trådløs MagSafe Oplader til Bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bii0.png?v=1732058781" loading="lazy">
        <p>Headset &<br>hovedtelefoner</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="/collections/mobil_kabel">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80.png?v=1732058291" loading="lazy">
        <p>Kabel &  <br>adaptere</p>
        </a></div> 

        
        <div style="background-color: #fff;" class="column100"><a href="/collections/ipad-8-gen-10-2-stander/products/delx-s1-holder-i-foldbar-design-til-smartphone-tablet-sort"><img alt="Hvid Magnetisk Trådløs Oplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/ogl.png?v=1686828994" loading="lazy">
        <p>DelX S1 Holder <br> Foldbar Design</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="/collections/mobil-tilbehor-gadgets/products/stylus-kapacitiv-touch-pen-til-tablet-smartphone"><img alt="DeLX™ - Kapacitiv Stylus Pen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Kapa.png?v=1686828260" loading="lazy">
        <p>DeLX™ Kapacitiv<br> Stylus Pen</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="/collections/apple-kabel-adapter/products/lightning-oplade-data-sync-kabel-til-iphone-ipad-hvid-1m"><img alt="Lightning Opladnings Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bilholder.png?v=1686828529" loading="lazy">
        <p>iPad / Tablet <br>Holder til Bil</p>
        </a></div>


        
        </div>
      </div>
	`);
}
<!-- iPad SLUT -->




<!-- .sale-discount-bach2 Start -->

(function () {
  // Compute highest % discount among variants
  function getBestDiscount(variants) {
    let best = 0;
    (variants || []).forEach(v => {
      const price = Number(v.price || 0);
      const compare = Number(v.compare_at_price || 0);
      if (compare > price && price > 0) {
        const pct = Math.round(((compare - price) / compare) * 100);
        if (pct > best) best = pct;
      }
    });
    return best;
  }

  // Add the badge
  function addBadge(cardEl, pct) {
    if (!pct || pct <= 0) return;
    if (cardEl.querySelector('.sale-discount-bach2')) return;
    const el = document.createElement('div');
    el.className = 'sale-discount-bach2';
    el.textContent = `-${pct}%`;
    el.setAttribute('aria-label', `${pct}% rabat`);
    cardEl.appendChild(el);
  }

  // Cache product JSON to avoid repeated fetches
  const cache = new Map();
  function fetchProduct(handle) {
    if (cache.has(handle)) return cache.get(handle);
    const p = fetch(`/products/${handle}.js`)
      .then(r => (r.ok ? r.json() : null))
      .catch(() => null);
    cache.set(handle, p);
    return p;
  }

  async function decorateCard(cardEl) {
    const handle = (cardEl.dataset && cardEl.dataset.handle || '').trim();
    if (!handle) return;

    const data = await fetchProduct(handle);
    if (!data || !Array.isArray(data.variants)) return;

    const pct = getBestDiscount(data.variants);
    addBadge(cardEl, pct);
  }

  function decorateAll(root = document) {
    root.querySelectorAll('.product-sync').forEach(decorateCard);
  }

  // Run once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(decorateAll, 0));
  } else {
    setTimeout(decorateAll, 0);
  }

  // Watch for dynamically added product boxes
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(n => {
        if (!(n instanceof HTMLElement)) return;
        if (n.matches && n.matches('.product-sync')) decorateCard(n);
        n.querySelectorAll && n.querySelectorAll('.product-sync').forEach(decorateCard);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

<!-- .sale-discount-bach2 Slut -->









